import React, { Fragment } from 'react'
import {
    forFeature,
    i18n,
} from '../../validator'
import Configurator from '../../configurator'
import MobileStoreLink from '../app-stores/mobile-store-link'
import {
    DEVICE_ANDROID,
    DEVICE_IOS,
} from '../../consts'
import classnames from 'classnames'
import { NavLink } from '../../front/components/shared/sn-link'

const sportnectLogoImage = '/images/logo-sportnect.svg'
const astrumqLogoImage = '/images/astrumq-logo.svg'
const facebookImage = '/images/facebook-white.svg'
const instagramImage = '/images/instagram-white.svg'

@forFeature('CITIES_FOOTER')
@i18n()
export default class Footer extends Configurator {
    /**
     * Render links column
     *
     * @return {XML}
     */
    renderLinksCol = () => {
        const footerLinks = this.config.REACT_APP_FOOTER_LINKS
        const footerLinksParsed = footerLinks || {}
        const { t } = this.props

        return (
            <Fragment>
                {!this.isOstravaSystem() &&
                    <Fragment>
                        <div className="mb-4">{t('aboutProject')}</div>
                        <ul>
                            {footerLinks && Object.keys(footerLinksParsed).map((link, index) => (
                                <li key={index}>
                                    <NavLink
                                        to={`/${link}`}
                                        className="footer__link"
                                    >
                                        {footerLinksParsed[link]}
                                    </NavLink>
                                </li>
                            ))}
                            <li className="pr-5">
                                <NavLink
                                    to="/o-projektu"
                                    onClick={this.scrollTop}
                                    className="footer__link"
                                >
                                    {t('aboutProject')}
                                </NavLink>
                            </li>
                            <li className="pr-5">
                                <NavLink
                                    to="/podminky-pouziti"
                                    onClick={this.scrollTop}
                                    className="footer__link"
                                >
                                    {t('termsAndConditionsFull')}
                                </NavLink>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${this.config.REACT_APP_CONTACT_EMAIL}`}
                                    className="footer__link"
                                >
                                    {t('contact')}
                                </a>
                            </li>
                        </ul>
                    </Fragment>
                }
            </Fragment>
        )
    }

    /**
     * Render (or not) watch us column
     *
     * @return {XML|null}
     */
    renderWatchUsCol = () => {
        const FBLink = this.config.REACT_APP_FOOTER_FACEBOOK_LINK
        const InstagramLink = this.config.REACT_APP_FOOTER_INSTAGRAM_LINK

        if (!FBLink && !InstagramLink) {
            return null
        }

        return (
            <Fragment>
                <div className="mb-4">Sledujte nás</div>
                {FBLink &&
                    <a href={this.config.REACT_APP_FOOTER_FACEBOOK_LINK} className="d-flex align-items-center mb-4">
                        <img src={facebookImage} alt="" />
                        <span className="ml-3 text-color-white">{this.config.REACT_APP_FOOTER_FACEBOOK_TAG}</span>
                    </a>
                }
                {InstagramLink &&
                    <a href={this.config.REACT_APP_FOOTER_INSTAGRAM_LINK} className="d-flex align-items-center">
                        <img src={instagramImage} alt="" />
                        <span className="ml-3 text-color-white">{this.config.REACT_APP_FOOTER_INSTAGRAM_TAG}</span>
                    </a>
                }
            </Fragment>
        )
    }

    /**
     * Render partners column
     *
     * @return {XML}
     */
    renderPartnersCol = () => (
        <Fragment>
            <div className="mb-4">Partneři projektu</div>
            <a href="https://sportnect.com" className="d-flex align-items-center mb-4">
                <img src={sportnectLogoImage} alt="" width="90" />
            </a>
            <a href="https://astrumq.com" className="d-flex align-items-center">
                <img src={astrumqLogoImage} alt="" />
            </a>
        </Fragment>
    )

    /**
     * Render (or not) mobile apps col
     *
     * @return {*}
     */
    renderMobileAppsCol = () => {
        if (!this.config.REACT_APP_FOOTER_MOBILE_TEXT) {
            return null
        }

        return (
            <Fragment>
                <div className="mb-4">Mobilní aplikace</div>
                <div className="d-flex flex-column">
                    <div className="mb-3 footer__mobile">
                        {this.config.REACT_APP_FOOTER_MOBILE_TEXT}
                    </div>
                    <div className="d-flex align-items-center flex-row align-content-between w-100 flex-wrap">
                        <MobileStoreLink forDevice={DEVICE_IOS} className="mr-4" />
                        <MobileStoreLink forDevice={DEVICE_ANDROID} />
                    </div>
                </div>
            </Fragment>
        )
    }

    /**
     * Render
     *
     * @return {XML}
     */
    render = () => (
        <footer className={classnames({
            'footer': true,
            [this.props.footerClass]: !!this.props.footerClass,
        })}>
            <div className="footer__main">
                <div className="footer__content flex-row">
                    <div className="footer__col">
                        {this.renderLinksCol()}
                    </div>
                    <div className="footer__col">
                        {this.renderWatchUsCol()}
                    </div>
                    <div className="footer__col">
                        {this.renderPartnersCol()}
                    </div>
                    <div className="footer__col">
                        {this.renderMobileAppsCol()}
                    </div>
                </div>
            </div>
            <div className="footer__sub">
                <div className="footer__content flex-row">
                    <div className="d-flex flex-row align-items-center">
                        <div className="mr-4" dangerouslySetInnerHTML={{ __html: this.config.REACT_APP_FOOTER_SUB_LOGO }} />
                        <div className="d-flex flex-row flex-wrap">
                            <span className="font-size-sm">{this.config.REACT_APP_SYSTEM_NAME}&nbsp;&copy;&nbsp;{new Date().getFullYear()}</span>
                            <span className="font-size-sm ml-2">{this.config.REACT_APP_FOOTER_SUB_CREATED}</span>
                            <span className="font-size-sm w-100">{this.config.REACT_APP_SYSTEM_NAME} běží na platformě <a href="https://sportnect.com" className="footer__sub-link">Sportnect</a> ({this.config.REACT_APP_VERSION})</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
